import * as React from 'react';

export type AdditionalServicesPriceType = {
    price: string;
    tax_percent: string;
    tax_amount: string;
    price_with_tax: string;
};

type AdditionalServicesContextType = {
    displayedFormValues: Partial<AdditionalServicesPriceType>;
    setDisplayedFormValues: React.Dispatch<React.SetStateAction<Partial<AdditionalServicesPriceType>>>;
};

const AdditionalServicesContext = React.createContext<AdditionalServicesContextType | undefined>(undefined);

export const AdditionalServicesProvider = ({ children }: { children: React.ReactNode }) => {
    const [displayedFormValues, setDisplayedFormValues] = React.useState<Partial<AdditionalServicesPriceType>>({
        price: '',
        tax_percent: '',
        tax_amount: '',
        price_with_tax: '',
    });

    const value = React.useMemo(() => {
        return { displayedFormValues, setDisplayedFormValues };
    }, [displayedFormValues]);

    return <AdditionalServicesContext.Provider value={value}>{children}</AdditionalServicesContext.Provider>;
};

export const useDisplayedAdditionalServicesFormValues = (): AdditionalServicesContextType => {
    const context = React.useContext(AdditionalServicesContext);
    if (!context) {
        throw new Error(
            'useDisplayedAdditionalServicesFormValues must be used within a AdditionalServicesContextProvider',
        );
    }
    return context;
};
